<template>
    <div>
        <el-dialog
                title="留言详情"
                :visible.sync="show"
                width="600px"
                 top="30px">
            <div v-loading="loading">
                <div class="w100 pl20 pr20">
                    <el-form label-width="100px" :model="form"  ref="ruleForm" class="demo-form-inline">
                        <!--<el-form-item label="留言时间" prop="name" style="min-width: 250px;">-->
                            <!--<el-input v-model="contentTime" readonly></el-input>-->
                        <!--</el-form-item>-->
                        <el-form-item label="留言详情" prop="name" style="min-width: 250px;">
                            <div class="msg-detail">
                                <div class="msg-item cl-f other">
                                    <div class="str-warp">
                                        <div class="msg-str" v-if="form._content">{{form._content}}</div>
                                    </div>
                                </div>
                                <div class="msg-item cl-f self" v-if="form.answer">

                                    <div class="str-warp">
                                        <div class="msg-str">{{form.answer}}</div>
                                    </div>
                                </div>
                            </div>
                           <!--<div class="msg-detail">-->
                               <!--<div v-for="(item,index) in msgList" class="msg-item cl-f"-->
                                    <!--:class="[item.answerBy!=form.answerBy?'other':'self']">-->
                                   <!--<div class="name-warp">-->
                                    <!--<span class="msg-name">{{item.answerBy!=form.answerBy?item.answerBy:'我'}}</span>-->
                                   <!--</div>-->
                                   <!--<div class="str-warp">-->
                                       <!--<div class="msg-str">{{item.content}}</div>-->
                                   <!--</div>-->



                               <!--</div>-->
                           <!--</div>-->
                        </el-form-item>
                        <!--<el-form-item label="回复" prop="content" style="min-width: 250px;">-->
                            <!--<el-input rows="5" v-model="form.content"-->
                                      <!--@keyup.enter.native="submitForm('ruleForm')"-->
                                      <!--type="textarea" placeholder="请输入"></el-input>-->
                        <!--</el-form-item>-->
                    </el-form>

                </div>

            </div>
            <!--<div slot="footer" class="dialog-footer">-->
                <!--<el-button @click="submitForm('ruleForm')" type="primary">确 定</el-button>-->
                <!--<el-button @click="show = false">取 消</el-button>-->
            <!--</div>-->
        </el-dialog>
    </div>
</template>

<script>
    import utils from '@/util/utils';
    import {getLeaveMsgRepeat,getLeaveMsgDetail} from '@/api/personalCenter/suggestAngMsg';
    export default {
        name: "answerMsgDialog",
        components: {},
        props: [],
        data() {
            return {
                contentTime:"",
                show: false,
                loading: false,
                msgList:[],
                form: {
                    answerBy: "",
                    answerTime: "",
                    content: "",
                    _content: "",
                    msgId: "",
                    serveId: ""
                },
                param:{},

            };
        },
        computed: {

        },
        methods: {
            // 显示弹框
            dialogShow(data) {

                this.show = true;
                    this.form._content=data.msgContent;
                    this.form.answer=data.answerContent;
                    this.contentTime=data.createTime;
                    this.form.msgId = data.msgId
                    this.form.serveId = data.serveId
                    this.form.answerBy = this.$store.getters.userData.userName

            },
            // getLeaveMsgDetail(){
            //     this.loading = true;
            //     getLeaveMsgDetail(this.param).then(({data})=>{
            //         this.loading = false;
            //         if(data.code == 0){
            //             this.msgList=(data.data||[]).reverse();
            //             this.$nextTick(() => {
            //                 let container = this.$el.querySelector(".msg-detail");
            //                 container.scrollTop = container.scrollHeight;
            //             });
            //         }else{
            //             this.$message.warning( "获取留言信息失败！" );
            //         }
            //     }).catch(err=>{
            //         this.loading = false;
            //     })
            //
            //
            // },
            getLeaveMsgRepeatFn(){
                this.loading = true;

                getLeaveMsgRepeat(this.form).then(({data})=>{
                    this.loading = false;
                    if(data.code == 0) {
                        this.show=false;
                        this.$message.success(  "留言成功!" );
                        this.$emit('saveSuccess')
                        this.form.content=''


                    }else{
                        this.$message.warning( data.msg|| "留言失败!" );
                    }
                }).catch(err=>{
                    this.loading = false;
                    this.$message.error(  "服务器异常!" );
                })
            },

            // 确定提交
            submitForm (formName) {
                if (!this.form.content) {
                    this.$message.warning("请输入要留言的内容!");
                    return;
                }

                this.getLeaveMsgRepeatFn()
            }
        },
        watch: {
            show(val){
                if(!val){

                    this.form.content=''
                }

            }

        },
        filters: {}
    };
</script>

<style scoped lang="less">
.msg-detail{
    border-radius: 4px;
    border: 1px solid #DCDFE6;
    height: 200px;
    overflow: auto;
    background: #F2F4F5;
    padding: 20px 0;
    .msg-item{
        padding: 2px 10px ;
        font-size: 12px;

        .msg-str{
            display: inline-block;
            max-width: 60%;
            padding:5px 10px ;
            border-radius:6px;
            line-height: 20px;

        }
    }
    .other{
        .name-warp{
            margin-top: 10px;
            height: 20px;
            line-height: 20px;
            text-align: left;
            padding-left: 5px;
        }
        .str-warp{
            text-align: left;
            .msg-str{
                background: #fff;
                position: relative;
                margin-left: 3px;
                &:before{
                    content: '';
                    display: block;
                    width: 0;
                    height: 0;
                    border: 8px solid transparent;
                    position: absolute;
                    top: 5px;
                    border-right: 8px solid #fff;
                    left: -13px;


                }
            }
        }

    }
    .self{
        .name-warp{
            margin-top: 10px;
            height: 20px;
            line-height: 20px;
            text-align: right;
            padding-right: 5px;
        }
        .str-warp{
            text-align: right;
            .msg-str{
                background: #8CE050;
                color: #fff;
                position: relative;
                margin-right: 3px;
                &:after{
                    content: '';
                    display: block;
                    width: 0;
                    height: 0;
                    border: 8px solid transparent;
                    position: absolute;
                    top: 5px;
                    border-left: 8px solid #8CE050;
                    right: -13px;

                }



            }

        }

    }


}


</style>
